/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Subscribed_Success_ContentInputs */

const en_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy exclusive trees, 3× rewards, and an ad-free experience.`)
};

const ar_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استمتع بأشجار حصرية، ومكافآت ثلاثية، وتجربة خالية من الإعلانات.`)
};

const de_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genießen Sie exklusive Bäume, 3× Belohnungen und ein werbefreies Erlebnis.`)
};

const es_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfruta de árboles exclusivos, recompensas triples y una experiencia sin anuncios.`)
};

const fr_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profitez d'arbres exclusifs, de récompenses triplées et d'une expérience sans publicité.`)
};

const it_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goditi alberi esclusivi, ricompense 3x e un'esperienza senza pubblicità.`)
};

const ja_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限定樹種、報酬3倍、広告なしの体験をお楽しみください。`)
};

const ko_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스페셜 트리, 리워드 3배 효과, 광고 없는 경험을 즐겨보세요.`)
};

const pt_br_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproveite as espécies exclusivas, 3× mais recompensas e uma experiência livre de anúncios.`)
};

const ru_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте эксклюзивные деревья и тройное вознаграждение, пользуйтесь без рекламы.`)
};

const th_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพลิดเพลินไปกับต้นไม้สุดพิเศษ รางวัลเพิ่ม 3 เท่า และประสบการณ์แบบไร้โฆษณา`)
};

const tr_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel ağaçların, 3 kat ödüllerin ve reklamsız bir deneyimin keyfini çıkar.`)
};

const zh_cn_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已解锁每季专属树种、3 倍专注奖励，以及无广告的专注体验！`)
};

const zh_tw_onboarding_paywall_subscribed_success_content = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已解鎖每季專屬樹種、3 倍專注獎勵，以及無廣告的專注體驗！`)
};

/**
* | output |
* | --- |
* | "Enjoy exclusive trees, 3× rewards, and an ad-free experience." |
*
* @param {Onboarding_Paywall_Subscribed_Success_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_subscribed_success_content = /** @type {((inputs?: Onboarding_Paywall_Subscribed_Success_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Subscribed_Success_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_subscribed_success_content(inputs)
	if (locale === "ar") return ar_onboarding_paywall_subscribed_success_content(inputs)
	if (locale === "de") return de_onboarding_paywall_subscribed_success_content(inputs)
	if (locale === "es") return es_onboarding_paywall_subscribed_success_content(inputs)
	if (locale === "fr") return fr_onboarding_paywall_subscribed_success_content(inputs)
	if (locale === "it") return it_onboarding_paywall_subscribed_success_content(inputs)
	if (locale === "ja") return ja_onboarding_paywall_subscribed_success_content(inputs)
	if (locale === "ko") return ko_onboarding_paywall_subscribed_success_content(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_subscribed_success_content(inputs)
	if (locale === "ru") return ru_onboarding_paywall_subscribed_success_content(inputs)
	if (locale === "th") return th_onboarding_paywall_subscribed_success_content(inputs)
	if (locale === "tr") return tr_onboarding_paywall_subscribed_success_content(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_subscribed_success_content(inputs)
	return zh_tw_onboarding_paywall_subscribed_success_content(inputs)
});